import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "preview-text relative"
};
const _hoisted_2 = {
  class: "h-full overflow-y-auto flex flex-col scroll-box"
};
const _hoisted_3 = ["title"];
const _hoisted_4 = {
  class: "relative pb-6 mt-2 flex-1"
};
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center items-center h-full"
};
import { ref, inject } from 'vue';
import ScreenFull from '@components/ScreenFull.vue';
import TextReader from '@components/TextReader.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewText',
  props: {
    textUrl: {},
    title: {}
  },
  setup(__props) {
    const props = __props;
    const screenFullRef = ref();
    const openSidePreview = inject('openSidePreview');
    const toggleFull = () => {
      openSidePreview({
        url: props.textUrl,
        title: props.title
      });
    };
    return (_ctx, _cache) => {
      const _component_i_home_full = _resolveComponent("i-home-full");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ScreenFull, {
        ref_key: "screenFullRef",
        ref: screenFullRef,
        class: "preview-box"
      }, {
        btn: _withCtx(() => [__props.textUrl ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "footer-btn",
          onClick: toggleFull
        }, [_createVNode(_component_i_home_full, {
          class: "w-2 h-2"
        }), _cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "ml-1"
        }, "查看全部内容", -1))])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: "title line-clamp-2 min-h-7",
          title: __props.title
        }, _toDisplayString(__props.title), 9, _hoisted_3), _createElementVNode("div", _hoisted_4, [__props.textUrl ? (_openBlock(), _createBlock(TextReader, {
          key: 0,
          url: __props.textUrl
        }, null, 8, ["url"])) : (_openBlock(), _createElementBlock("div", _hoisted_5, "请先选择预览的知识库"))])])]),
        _: 1
      }, 512)]);
    };
  }
});